import React, { useCallback } from "react";
import PT from "prop-types";
import NewEventFab from "_c/NewEventFab";

const CreateOrderFab = (props) => {
  const onTaskClick = useCallback(() => {
    props.openTaskEditor();
  }, []);
  const onPersonalTaskClick = useCallback(() => {
    props.openTaskEditor({ personal: true });
  }, []);
  return (
    <NewEventFab
      t={props.t}
      onTaskClick={onTaskClick}
      onPersonalTaskClick={onPersonalTaskClick}
    />
  );
};
CreateOrderFab.propTypes = {
  openTaskEditor: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default CreateOrderFab;
